import { Phone, MapPin, Mail, Facebook, Instagram } from "lucide-react";
import PageHero from "../components/PageHero";
import QuoteForm from "../components/QuoteForm";
import { Reveal } from "../components/Reveal";
import { company, galleryImages } from "../data/site";

const Contact = () => (
  <div data-testid="contact-page">
    <PageHero
      overline="Contact Us"
      title="Get your free quote."
      subtitle="We stay in constant communication with our customers until the job is done. Questions or special requests? Just drop us a line."
      image={galleryImages[3]}
    />

    <section className="py-24 md:py-32 bg-bone">
      <div className="container-fl grid md:grid-cols-12 gap-16">
        <Reveal className="md:col-span-5">
          <p className="overline mb-5">Fresh Landscaping</p>
          <h2 className="text-4xl md:text-5xl leading-tight mb-10">Let's talk about your project.</h2>

          <div className="space-y-6">
            <a href={company.phoneHref} data-testid="contact-phone" className="flex items-center gap-4 group">
              <span className="w-12 h-12 flex items-center justify-center border border-line group-hover:bg-forest group-hover:text-bone transition-colors"><Phone size={20} strokeWidth={1.5} /></span>
              <span><span className="block overline mb-1">Call Us</span><span className="text-xl text-ink">{company.phone}</span></span>
            </a>
            <div className="flex items-center gap-4">
              <span className="w-12 h-12 flex items-center justify-center border border-line"><MapPin size={20} strokeWidth={1.5} /></span>
              <span><span className="block overline mb-1">Service Area</span><span className="text-xl text-ink">{company.location}</span></span>
            </div>
            <a href="mailto:freshlandscapealberta@gmail.com" data-testid="contact-email" className="flex items-center gap-4 group">
              <span className="w-12 h-12 flex items-center justify-center border border-line group-hover:bg-forest group-hover:text-bone transition-colors"><Mail size={20} strokeWidth={1.5} /></span>
              <span><span className="block overline mb-1">Email</span><span className="text-lg text-ink break-all">freshlandscapealberta@gmail.com</span></span>
            </a>
          </div>

          <div className="flex items-center gap-4 mt-10">
            <a href={company.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-11 h-11 flex items-center justify-center border border-line hover:bg-forest hover:text-bone transition-colors"><Facebook size={18} /></a>
            <a href={company.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-11 h-11 flex items-center justify-center border border-line hover:bg-forest hover:text-bone transition-colors"><Instagram size={18} /></a>
            <a href={company.social.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="w-11 h-11 flex items-center justify-center border border-line hover:bg-forest hover:text-bone transition-colors text-sm font-semibold">TT</a>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="md:col-span-7 bg-sand p-8 md:p-12">
          <h3 className="text-3xl mb-8">Request a Free Quote</h3>
          <QuoteForm />
        </Reveal>
      </div>
    </section>
  </div>
);

export default Contact;
